import { render, staticRenderFns } from "./commonBox.vue?vue&type=template&id=4b316907&scoped=true"
import script from "./commonBox.vue?vue&type=script&lang=js"
export * from "./commonBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b316907",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b316907')) {
      api.createRecord('4b316907', component.options)
    } else {
      api.reload('4b316907', component.options)
    }
    module.hot.accept("./commonBox.vue?vue&type=template&id=4b316907&scoped=true", function () {
      api.rerender('4b316907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/commonBox.vue"
export default component.exports